(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-article"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ccArticleReady === 'true') return;
      root.dataset.ccArticleReady = 'true';
      const content = root.querySelector('[data-article-content]');
      if (!content) return;
      const minuteTarget = root.querySelector('[data-reading-minutes]');
      if (minuteTarget) {
        const words = content.textContent.trim().split(/\s+/).filter(Boolean).length;
        minuteTarget.textContent = Math.max(1, Math.ceil(words / 220));
      }
      const toc = root.querySelector('[data-article-toc]');
      const list = root.querySelector('[data-toc-list]');
      if (!toc || !list) return;
      const headings = [...content.querySelectorAll('h2')];
      if (headings.length < 2) return;
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `cc-heading-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      toc.hidden = false;
      const links = [...list.querySelectorAll('a')];
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${entry.target.id}`));
          });
        }, { rootMargin: '-18% 0px -68% 0px' });
        headings.forEach((heading) => observer.observe(heading));
      }
    };
    document.querySelectorAll('[data-cc-article]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-cc-article]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
